import { Box, styled } from '@mui/material';

import { LoanExampleText } from '@/components/LoanExampleText/index.ts';

import { SIZES } from '../../../../../../assets/constants/constants.ts';
import Dots from '../../../../../../assets/images/dots_doodle.svg?react';
import Line from '../../../../../../assets/images/line_doodle_2.svg?react';
import LineSm from '../../../../../../assets/images/line_doodle_2_sm.svg?react';
import RefinancingCardIcon from '../../../../../../assets/images/products/refinancing_card.svg';
import ActionButton from '../../../../../../components/ActionButton/index.ts';
import Section from '../../../../../../components/Section/index.ts';
import SectionTitle from '../../../../../../components/SectionTitle/index.ts';
import WhyWeList from '../../../../../../components/WhyWeList/index.ts';

const SectionContent = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  maxWidth: SIZES.layout.width.sm,
  margin: 'auto',
  flexDirection: 'column',
  textAlign: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: `calc(100vh - ${theme.spacing(16)}px - ${SIZES.topBar.height.large}px)`,
}));

const TitleContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  [theme.breakpoints.between(0, 360)]: {
    width: 'min-content',
  },
  [theme.breakpoints.between('sm', 740)]: {
    width: 'min-content',
  },
  [theme.breakpoints.up(310)]: {
    marginTop: theme.spacing(4),
  },
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(8),
  },
}));

const TitleText = styled('h1')(({ theme }) => ({
  fontSize: '2rem',
  [theme.breakpoints.up('sm')]: {
    fontSize: '4.5rem',
  },
}));

const StyledLine = styled(Box)(({ theme }) => ({
  position: 'absolute',
  width: 120,
  right: -10,
  bottom: -5,
  [theme.breakpoints.up(280)]: {
    width: 155,
    right: 20,
  },
  [theme.breakpoints.up(360)]: {
    width: 155,
    right: 55,
  },
  [theme.breakpoints.up('sm')]: {
    right: 140,
    width: 370,
    bottom: 0,
  },
}));

const StyledDots = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 42,
  right: -16,
  [theme.breakpoints.up(280)]: {
    top: 30,
    right: 10,
  },
  [theme.breakpoints.up(320)]: {
    top: 30,
    right: -20,
  },
  [theme.breakpoints.up(360)]: {
    top: 30,
    right: 5,
  },
  [theme.breakpoints.up(412)]: {
    top: -10,
    right: -28,
  },
  [theme.breakpoints.up('sm')]: {
    top: 100,
    right: 40,
  },
  [theme.breakpoints.up(830)]: {
    top: 10,
    right: -20,
  },
}));

const SubtitleText = styled('h2')(({ theme }) => ({
  position: 'relative',
  margin: theme.spacing(4, 0, 6),
  maxWidth: 330,
  [theme.breakpoints.up('sm')]: {
    fontSize: '1.75rem',
    maxWidth: 500,
  },
}));

const SimplifiedBobDoodle: React.FC = () => {
  return (
    <>
      <Section background="paper">
        <SectionContent>
          <TitleContainer>
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
              <StyledDots>
                <Dots />
              </StyledDots>
            </Box>
            <TitleText className="typography-v1-legacy-h1">
              Sjekk sparepotensialet
              <br />
              på 1 minutt
            </TitleText>
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
              <StyledLine>
                <Line />
              </StyledLine>
            </Box>
            <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
              <StyledLine>
                <LineSm />
              </StyledLine>
            </Box>
          </TitleContainer>
          <SubtitleText className="typography-v1-legacy-subtitle1">
            Se <strong>hvor mye du kan spare</strong> med lavere rente på dine kredittkort eller
            forbrukslån
          </SubtitleText>

          <ActionButton
            label="Sjekk nå"
            flow="debt_check"
            step="skip_start_set_savings_potential_mode"
            color="primary"
            id="id_auto"
          />

          <p className="mt-4 flex text-xs leading-normal text-v1-background-200 italic sm:text-sm">
            Trygt og raskt med BankID
          </p>

          <div className="mt-12 max-w-175 typography-v1-legacy-p3 text-v1-neutral-100 sm:mt-36 md:mt-20">
            <LoanExampleText />
          </div>
        </SectionContent>
      </Section>
      <Section>
        <SectionTitle title="Hvorfor velge oss" />

        <WhyWeList
          textsLeft={[
            'Superenkel sjekk med BankID',
            'Snittbesparelse 9.800 kroner per år',
            'I snitt sparer kundene våre 50.000 totalt',
          ]}
          textsRight={[
            'I snitt reduseres nedbetalingstiden med 2 år',
            'Søknaden din behandles straks hos alle våre banker',
          ]}
          icon={RefinancingCardIcon}
        />
        <ActionButton
          label="Sjekk nå"
          flow="debt_check"
          step="skip_start_set_savings_potential_mode"
          color="secondary"
        />
      </Section>
    </>
  );
};

export default SimplifiedBobDoodle;
